var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTokenIconWalletSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 26.5,
    stroke: "#BF96FF",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.2711 20.2501V14.5225H28.361V44.7451L30.0792 41.6984V16.2406H40.553V18.5319H31.0612V39.9568L32.7794 36.9101V20.2501H42.2711Z",
    fill: "#bf96ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6066 20.2501V14.5225H27.5167V44.7451L25.7986 41.6984V16.2406H15.3248V18.5319H24.8165V39.9568L23.0984 36.9101V20.2501H13.6066Z",
    fill: "#bf96ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenIconWalletSend);
export default __webpack_public_path__ + "static/media/token_icon_wallet_send.7ee47eb09b3372a0442b9ecc76a95ea7.svg";
export { ForwardRef as ReactComponent };